export default __webpack_public_path__ + "static/media/Metropolis-MediumItalic.9f90cbf8.otf";